import React, { useContext } from 'react'
import MarkdownHelper from '../utils/MarkdownHelper'
import ReactMarkdown from "react-markdown"
import { SuperscriptContext } from '../utils/SuperscriptHelper'

const FNREGEX = /{fn.}/gi
const FN_WARNING_TEXT = 'Bitte beachten: Fußnote wird auf Offer Page angezeigt.'

export const FootnotesFromContext = (
    /** @type {{ footnotes: string[], bigIndices: boolean, showWarningText: boolean }} */
    props
) => {
    const superscriptContext = useContext(SuperscriptContext)
    if (!superscriptContext) {
        throw new Error('FootnotesFromContext must be used inside a SuperscriptProvider')
    }
    const { parsed, footnotes } = superscriptContext

    const FnIndexWrapper = ({ children }) => props.bigIndices ? <strong>{children}</strong> : <sup>{children}</sup>        

    const zipped = Object.entries(footnotes).map(([key, value]) => ({label: key, index: value, text: parsed[key]}))
    zipped.sort((a, b) => a.index - b.index)

    if (parsed.length === 0) {
        return ''
    }

    return (
        <ul className="footnotes">
            { props.showWarningText && (zipped || []).length > 0 &&
                <div className="footnotes-warning">
                    {FN_WARNING_TEXT}
                </div>
            }
            {zipped.map((item) => (
                <li key={item.index}>
                    <FnIndexWrapper>{item.index}</FnIndexWrapper>
                    <ReactMarkdown
                        {...MarkdownHelper.basicTypes()}
                        source={MarkdownHelper.parse(item.text || '-')}
                        escapeHtml={false}
                    />
                </li>
            ))}
        </ul>
    )
}

const Footnotes = (props) => {
    if(props.uniqueFnValues && props.footnotes) {

        const footnotesObject = {}
        props.footnotes.split('*').filter(el=>el!=='').forEach(el=>footnotesObject[el.match(FNREGEX)]= el.replace(FNREGEX, '').trim())

        const FnIndexWrapper = ({ children }) => props.bigIndices ? <strong>{children}</strong> : <sup>{children}</sup>

        const footnotesList = props.uniqueFnValues.map((fn, i) => (
            <li key={`${fn}-${i}`}>
                <FnIndexWrapper>{i + 1}</FnIndexWrapper>
                <ReactMarkdown
                    {...MarkdownHelper.basicTypes()}
                    source={footnotesObject[fn]}
                    escapeHtml={false}
                />
            </li>
        ))

        const footnotesWarningText = 'Bitte beachten: Fußnote wird auf Offer Page angezeigt.';

        return (
            <ul className="footnotes">
                <div className="footnotes-warning" style={props.footnotesWarningText ? {display: 'block'} : {display: 'none'}}>{footnotesWarningText}</div>
                {footnotesList}
            </ul>
        )
    } else {
        return ''
    }
}

export default Footnotes



// WEBPACK FOOTER //
// ./src/components/subcomponents/Footnotes.js